import React, {
  useEffect,
  useState
} from 'react'
import ImageGallery from 'react-image-gallery'
import { Box } from '@mui/material'
import { StorefrontProduct } from '@/modules/product/types/product'
import ChronoLinkButton from '@/layouts/core/components/ChronoLinkButton'
import ChronoModal from '@/layouts/core/components/ChronoModal'

import 'react-image-gallery/styles/css/image-gallery.css'

type GalleryImage = {
  original: string
  thumbnail: string
}

export const ProductImages = ({ product, sx }: { product: StorefrontProduct, sx?: any }) => {
  const [images, setImages] = useState<GalleryImage[]>()

  useEffect(() => {
    const images = product.images.map(img => ({
      original: img.url,
      thumbnail: img.url,
      originalHeight: 300
    }))
    setImages(images)
  }, [product.images])

  return (
    <Box 
      data-cy={`product_images_${product.sku}`}
      sx={sx}>

      <ChronoModal
        size={'lg'}
        renderButton={(cb) => (
          <ChronoLinkButton 
            data-cy={'product_view_images'}
            onClick={cb}>
            View<br/>Images
          </ChronoLinkButton>
        )}>

        <ImageGallery 
          showThumbnails={true}
          showBullets={true}
          showPlayButton={false}
          items={images}/>

      </ChronoModal>

    </Box>
  )
}